<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>会员编号：</label>
                <el-input v-model="search_Obj.f_member_code" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>姓名：</label>
                <el-input v-model="search_Obj.f_name" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>手机号：</label>
                <el-input v-model="search_Obj.f_cellphone" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>推广等级：</label>
                <el-select v-model="search_Obj.f_level" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('promotion_level')" :key="'promotion_level'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>状态：</label>
                <el-select v-model="search_Obj.f_state" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('userstate')" :key="'userstate'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="member_code" label="会员编号" sortable="custom"></el-table-column>
                <el-table-column prop="name" label="姓名" sortable="custom"></el-table-column>
                <el-table-column prop="cellphone" label="手机号" sortable="custom"></el-table-column>
                <el-table-column prop="level" label="等级" sortable="custom" width="120">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.level, "promotion_level") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="状态" sortable="custom" width="120">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.state, "userstate") }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="balance_settled" label="已结算" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="balance_ready" label="本期结算" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="balance_wait" label="等待结算" sortable="custom" width="120"></el-table-column>
                <el-table-column prop="add_time" label="添加时间" sortable="custom"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看推广达人"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
        <Settled
            width="600px"
            :member_id="member_id"
            title="结算"
            :isshow="settledshow"
            @on-close="closeSettledDialog"
            @on-save-ok="settledOk">
        </Settled>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import Settled from "../promotionsettled/edit"
import listutil from "@/libs/listutil"

export default {
    name: 'promotionMemberList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns, Settled},
    data() {
        return {
            m_name: '推广达人',
            menu_id: 7600,
            list_url: "/api/admin/promotionmember/list",
            search_Obj: {
                f_member_code: '',
                f_name: '',
                f_cellphone: '',
                f_level: '',
                f_state: '',
            },
            del_Obj:{
                url:'/api/admin/promotionmember/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['userstate','promotion_level'],
            settledshow: false,
            member_id: 0,
        };
    },
    methods: {
        settled(index, row){
            this.member_id = row.member_id
            this.settledshow = true
        },
        closeSettledDialog() {
            this.settledshow = false
        },
        settledOk() {
            this.settledshow = false
            this.getListData()
        },
    }
};
</script>